import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FiltersModule } from '../filters/filters.module';
import { JwtInterceptor } from '../helpers/jwt.interceptor';
import { UserService } from '../services/identity/user.service';
import { ImageService } from '../services/shared/image.service';
import { SharedModule } from '../shared/shared.module';
import { OnboardingCommunityMembersComponent } from './components/onboarding-community-members/onboarding-community-members.component';
import { OnboardingUserCompletionComponent } from './components/onboarding-user-completion/onboarding-user-completion.component';
import { OnboardingUserInfosComponent } from './components/onboarding-user-infos/onboarding-user-infos.component';
import { OnboardingUserInterestsComponent } from './components/onboarding-user-interests/onboarding-user-interests.component';
import { OnboardingUserSkillsComponent } from './components/onboarding-user-skills/onboarding-user-skills.component';
import { ProfileModalComponent } from './components/widget-connect/profile-modal/profile-modal.component';
import { HomeRoutingModule } from './home-routing.module';
import { HomeComponent } from './home.component';
import { ContactUsComponent } from './pages/contact-us/contact-us.component';
import { ExternalLinksPageComponent } from './pages/external-links-page/external-links-page.component';
import { HelpPageComponent } from './pages/help-page/help-page.component';
import { HomePageComponent } from './pages/home-page/home-page.component';
import { OnboardingPageComponent } from './pages/onboarding-page/onboarding-page.component';

import { PublicationModule } from '../shared/components/publication/publication.module';
import { UserModule } from '../user/user.module';
import { DrawerNotificationPostComponent } from './components/drawer-notification-post/drawer-notification-post.component';
import { DrawerNotificationComponent } from './components/drawer-notification/drawer-notification.component';
import { WidgetConnectFiltersComponent } from './components/widget-connect/widget-connect-modal/widget-connect-filters/widget-connect-filters.component';
import { WidgetConnectModalComponent } from './components/widget-connect/widget-connect-modal/widget-connect-modal.component';
import { WidgetConnectComponent } from './components/widget-connect/widget-connect.component';
import { WidgetEventComponent } from './components/widget-event/widget-event.component';
import { WidgetInfoComponent } from './components/widget-info/widget-info.component';
import { WidgetInviteComponent } from './components/widget-invite/widget-invite.component';
import { WidgetProgressComponent } from './components/widget-progress/widget-progress.component';
import { WidgetProjectComponent } from './components/widget-project/widget-project.component';
import { WidgetPublicationComponent } from './components/widget-publication/widget-publication.component';
import { WidgetRegistrationListComponent } from './components/widget-registration-list/widget-registration-list.component';

@NgModule({
    declarations: [
        HomeComponent,
        HomePageComponent,
        ContactUsComponent,
        HelpPageComponent,
        ExternalLinksPageComponent,
        OnboardingPageComponent,
        OnboardingUserInfosComponent,
        OnboardingUserSkillsComponent,
        OnboardingUserInterestsComponent,
        OnboardingUserCompletionComponent,
        OnboardingCommunityMembersComponent,

        WidgetProgressComponent,
        WidgetConnectComponent,
        WidgetInviteComponent,
        WidgetInfoComponent,
        WidgetPublicationComponent,
        WidgetProjectComponent,
        WidgetEventComponent,
        WidgetRegistrationListComponent,
        ProfileModalComponent,

        DrawerNotificationComponent,
        DrawerNotificationPostComponent,
        WidgetConnectModalComponent,
        WidgetConnectFiltersComponent,
    ],
    imports: [CommonModule, HttpClientModule, HomeRoutingModule, FiltersModule, SharedModule, FormsModule, ReactiveFormsModule, UserModule, PublicationModule],
    providers: [UserService, ImageService, { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true }],
})
export class HomeModule {}
